import { create } from 'zustand';

import type { Tenant } from '@/type';

import useTenantStore from '../tenantStore';
import type { DelegationStoreActions, DelegationStoreState } from './type';

const INIT_STATE: DelegationStoreState = {
  tenant: null,
};

const useDelegationStore = create<
  DelegationStoreState & DelegationStoreActions
>((set, get) => {
  const getTenantStoreState = () => useTenantStore.getState();

  INIT_STATE.tenant = getTenantStoreState().tenantList.find(
    tenant => tenant.delegation,
  );

  return {
    ...INIT_STATE,

    clear() {
      const tenant = get().tenant;
      const { removeTenant, selectFirstTenant } = getTenantStoreState();

      if (!tenant) return;

      set({ tenant: null });
      removeTenant(tenant.tenantID);
      selectFirstTenant();
    },

    setDelegationTenant(tenant) {
      const { addTenant, selectTenant } = getTenantStoreState();

      set({ tenant });
      addTenant({ ...tenant, delegation: true } as Tenant);
      selectTenant(tenant.tenantID);
    },
  };
});

export default useDelegationStore;
